import { Footprints } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#F8FAFC] border-t hairline pt-16 pb-10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src="/amcares-logo-transparent.png" alt="AMCares Foundation" className="h-20 md:h-24 w-auto mb-5" />
          <p className="text-brand-ink/60 max-w-sm leading-relaxed text-sm">
            AMCares is a student-led community hygiene initiative — assembling and distributing essential hygiene kits and
            health education to underserved families through trusted healthcare partners like Lifeline Primary Care.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm font-bold uppercase tracking-wide text-brand-ink mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-brand-ink/60">
            {[["Mission", "#mission"], ["Hygiene Kits", "#kits"], ["Impact", "#impact"], ["Programs", "#programs"], ["Get Involved", "#involved"]].map(([l, h]) => (
              <li key={h}>
                <a href={h} className="hover:text-brand-blue transition-colors">{l}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-sm font-bold uppercase tracking-wide text-brand-ink mb-4">Our Commitment</h4>
          <p className="text-sm text-brand-ink/60 leading-relaxed">
            Every kit is assembled with care and paired with a simple health-education handout. We partner directly with
            community clinics so support reaches patients who need it most — reinforcing healthy habits well beyond the
            clinic visit.
          </p>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t hairline flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-brand-ink/40">© {new Date().getFullYear()} AMCares · Connecting Communities to Better Health</p>
        <p className="text-xs text-brand-ink/40 flex items-center gap-2">
          <Footprints className="h-3.5 w-3.5 text-brand-green" /> Serving Georgia & beyond
        </p>
      </div>
    </div>
  </footer>
);
